module.exports = __webpack_public_path__ + "static/img/no_give_icon.88c95cfa.png";